import { useCallback, useState } from "react";
import { getStaff, getGroups } from "../../../components/access/functions";

export function useAccessData(user) {
  const [staff, setStaff] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!user?.token) {
      return;
    }
    setLoading(true);
    setError(null);

    const [staffData, groupsData] = await Promise.all([
      getStaff(user.token),
      getGroups(user.token),
    ]);

    if (staffData?.type === "error") {
      setError(staffData);
      setStaff([]);
    } else {
      setStaff(staffData?.data ?? []);
    }
    setGroups(groupsData?.type === "success" ? groupsData.data ?? [] : []);
    setLoading(false);
  }, [user?.token]);

  return { staff, groups, loading, error, refresh };
}
